export default __webpack_public_path__ + "static/media/awaiting4S.ac4da7e7.svg";